import { getSelectedPeriod } from "../../../../services/GroupContext";
import { getNonConsentingStatus } from "../utils/fullReturnOutputUtils";
import {
  getCompanyNtiei,
  getCompanyTaxEbitda,
  getRelevantGroupCompanies,
} from "../utils/helpers";

export const getGroupSummaryAndCompaniesSection = (excelData) => {
  const companies = getRelevantGroupCompanies();

  const ukGroupCompaniesTabList = [];
  const nonConsentingCompMap = getNonConsentingStatus(getSelectedPeriod(), companies);
  companies?.forEach((comp) => {
    const companyName = comp?.company_name;
    const consentStatus = nonConsentingCompMap.get(comp.company_ID)
      ? "Non-consenting"
      : "Consenting";
    const qicElection = comp?.election_s433_s434 ? "Yes" : "No";
    const ntiei = getCompanyNtiei(comp?.company_ID);
    const taxEbitda = getCompanyTaxEbitda(comp?.company_ID);

    ukGroupCompaniesTabList.push([
      "",
      companyName,
      consentStatus,
      qicElection,
      ntiei,
      taxEbitda,
    ]);
  });

  return [
    [],
    ["", "Summary of calculations"],
    [],
    ["", ...excelData.subject_interest_restriction],
    ["", ...excelData.total_dissallowed_amount],
    ["", ...excelData.subject_reactivations],
    ["", ...excelData.interest_reactivation_cap],
    [],
    ["", ...excelData.aggregate_net_tax_interest_expense],
    ["", ...excelData.aggregate_net_tax_interest_income],
    ["", ...excelData.aggregate_tax_ebitda],
    ["", ...excelData.interest_allowance_brought_forward],
    ["", ...excelData.interest_allowance_for_period],
    ["", ...excelData.interest_capacity_for_period],
    [],
    ["", ...excelData.adjusted_net_group_interest_expense],
    [],
    ["", ...excelData.qualifying_ngie],
    ["", ...excelData.group_ebitda_summary],
    ["", ...excelData.group_ratio_summary],
    [],
    [],
    [
      "",
      "UK Group companies",
      "Consent status",
      "QIC election?",
      "Net tax-interest expense / (income)",
      "Tax-EBITDA",
    ],
    ...ukGroupCompaniesTabList,
  ];
};
